import React, { Suspense } from "react";

const CreditManagement = React.lazy(() => import("@/pages/credit-management"));

export default function CreditManagementContainer() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div></div>}>
      <CreditManagement />
    </Suspense>
  );
}
